
        import 'Toggle.31e0c87.css-module'
        export default {"Toggle":"Toggle_Toggle_31e0c87"}
    